import discountsActionTypes from './action-types';

export const fetchDiscountsList = payload => ({
  type: discountsActionTypes.FETCH_DISCOUNTS_LIST,
  payload,
});

export const fetchDiscountsListSuccess = payload => ({
  type: discountsActionTypes.FETCH_DISCOUNTS_LIST_SUCCESS,
  payload,
});

export const fetchDiscountsListFail = payload => ({
  type: discountsActionTypes.FETCH_DISCOUNTS_LIST_FAIL,
  payload,
});

export const searchProducts = payload => ({
  type: discountsActionTypes.SEARCH_PRODUCTS,
  payload,
});

export const searchProductsSuccess = payload => ({
  type: discountsActionTypes.SEARCH_PRODUCTS_SUCCESS,
  payload,
});

export const searchProductsFail = payload => ({
  type: discountsActionTypes.SEARCH_PRODUCTS_FAIL,
  payload,
});

export const createDiscount = payload => ({
  type: discountsActionTypes.CREATE_DISCOUNT,
  payload,
});

export const createDiscountSuccess = () => ({
  type: discountsActionTypes.CREATE_DISCOUNT_SUCCESS,
});

export const createDiscountFail = payload => ({
  type: discountsActionTypes.CREATE_DISCOUNT_FAIL,
  payload,
});

export const updateDiscount = payload => ({
  type: discountsActionTypes.UPDATE_DISCOUNT,
  payload,
});

export const updateDiscountSuccess = () => ({
  type: discountsActionTypes.UPDATE_DISCOUNT_SUCCESS,
});

export const updateDiscountFail = payload => ({
  type: discountsActionTypes.UPDATE_DISCOUNT_FAIL,
  payload,
});

export const fetchOffersProducts = payload => ({
  type: discountsActionTypes.FETCH_OFFERS_PRODUCTS,
  payload,
});

export const fetchOffersProductsSuccess = payload => ({
  type: discountsActionTypes.FETCH_OFFERS_PRODUCTS_SUCCESS,
  payload,
});

export const fetchOffersProductsFail = payload => ({
  type: discountsActionTypes.FETCH_OFFERS_PRODUCTS_FAIL,
  payload,
});

export const performOfferAction = payload => ({
  type: discountsActionTypes.PERFORM_OFFER_ACTION,
  payload,
});

export const performOfferActionSuccess = () => ({
  type: discountsActionTypes.PERFORM_OFFER_ACTION_SUCCESS,
});

export const performOfferActionFail = payload => ({
  type: discountsActionTypes.PERFORM_OFFER_ACTION_FAIL,
  payload,
});
